module.exports = __webpack_public_path__ + "static/media/video-santa-fe.3dc34ab2.jpg";